import * as en from 'rev.sdk.js/Locale/en';

const labels = {
  ...en.labels,
  intro: 'Introduction',
  spec: 'Specification',
  remark: 'Remark',
  share_link: 'Share Link',
  confirm: 'Confirm',
  customer_support: 'Contact',
  customer_support_title: 'About what',
  customer_support_content: 'Detailed description',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  updated: 'Updated time',
  next_article: 'Next Article',
  prev_article: 'Previous Article',
  cart: 'Cart',
  cart_add: 'Add To Cart',
  cart_add_error_message_items_limit: '超過購物車購買上限，請分批購買en',
  cart_add_error_message:
    'Error, please click clear cart in profile page, and try add again',
  cart_clear: 'Clear Cart',
  cart_clear_success: 'Clear cart successfully',
  cart_clear_failure: 'Clear cart failed, please ask customer service.',
  cart_empty_content: 'Cart is Empty! Welcome to make your selection.',
  cart_invalid_date: 'Invalid date. Choose other date please.',
  cart_invalid_extra_data: 'Some variants are imcompleted.',
  cart_date_mismatch: 'Date is mismatch with items of cart.',
  cart_logistics_mismatch: 'Logistic type is mismatch with items of cart.',
  cart_thermosphere_mismatch:
    'Temperature Zone is mismatch with items of cart.',
  cart_config_mismatch: 'Something mismatch with items of cart',
  cart_invalid_qty:
    'Limited to one with delivery home order. Please purchase separately.',
  cart_exceed_limit:
    'Delivery home item in cart exceeds the limit. Please purchase separately.',
  buy_now: 'Buy Now',
  checkout_info: 'Checkout information',
  cart_empty: 'Cart Empty',
  sale_start_time: '供應開始時間en',
  sale_end_time: '供應結束時間en',
  store_info: 'store information',
  contact_us: 'contact us',
  customer_order_question: 'customer / order',
  business_coop: 'business cooperation',
  customer_service: 'customer service',
  uni_no: 'uni number',
  store_intro: 'Store introduction',
  faq: 'FAQ',
  agree_policy_if_register: 'Agree policies if account registered',
  privacy_policy: 'Privacy policy',
  and: '&',
  service_policy: 'Service policy',
  wait: 'Please wait',
  profile: 'Profile',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  login_way: 'Login way',
  action: 'Action',
  reset: 'Reset',
  submit: 'Submit',
  zip_code: 'Zip code',
  city: 'City',
  district: 'district',
  address: 'Address',
  order_title: 'My Orders',
  reset_password: 'Reset password',
  original_pwd: 'Original password',
  new_pwd: 'New password',
  new_pwd_again: 'Confirm new password',
  forgot_pwd: 'Forgot password',
  success: 'Success',
  confirm_email_for_reset_pwd:
    'Click verify link in your email inbox to reset password.',
  failed: 'Failed',
  fail_again: 'Failed, please try again',
  send_verify_email: 'Send verify email',
  please_enter: 'Please enter ',
  please_select: 'Please select ',
  reset_pwd_success_and_login:
    'Password is already reset. Now login by your new password.',
  register_new_account: 'Register new account',
  confirm_email_for_register:
    'Click verify link in your email inbox to register account.',
  register: 'Register',
  register_complete: 'Register complete',
  account_created_now_login: 'Your account is created. Login by your account.',
  pwd_again: 'Confirm password',
  sold_out: 'sold out',
  product_list: 'products',
  news: 'news',
  logistics_type: 'Logistic Type',
  eta: 'Estimate Pick / Delivery Date',
  reminder: 'Reminder',
  line_redirect: 'Line Account Login',
  redirect_waiting: 'Try to redirect, please wait',
  shopping: 'Shop Now',
  back_products: 'Go Back Product List',
  payment: 'Payment',
  authentication_processing: 'Authentication processing',
  price_information: 'Price information',
  subtotal: 'Subtotal',
  total: 'Total',
  prev_step: 'Previous Step',
  next_step: 'Next Step',
  temperature_zone: 'Temperature Zone',
  payment_logistics_section_title: 'Payment & Logistic',
  buyer_name: 'Name',
  buyer_phone: 'Phone',
  buyer_email: 'Email',
  buyer_address: 'Address',
  buyer_tel: 'Tel',
  tel: 'Tel',
  buyer_tel_ext: 'Tel extension',
  receiver_info: 'Receiver information',
  receiver_name: 'Name',
  receiver_phone: 'Phone',
  receiver_email: 'Email',
  receiver_address: 'Address',
  receiver_tel: 'Tel',
  receiver_tel_ext: 'Tel extension',
  logistics_provider: 'Provider',
  invoice_info: 'Invoice information',
  extra_info: 'Extra information',
  payment_method: 'Payment type',
  tel: 'Tel',
  zip_code: 'Zip code',
  city: 'City',
  district: 'District',
  address: 'Address',
  note: 'Note',
  invoice_type: 'Invoice',
  invoice_status: 'Invoice status',
  invoice_number: 'Invoice No.',
  random_code: 'Random code',
  uni_number: 'Uni number',
  love_code: 'Donate code',
  carrier_type: 'Carrier type',
  carrier_no: 'Carrier No.',
  citizen_digital_certificate: 'Citizen digi cert',
  company_name: 'Company name',
  checkout: 'Checkout',
  logistics_info: 'Logistic information',
  logistics_id: 'Logistic ID',
  logistics_status: 'Logistic status',
  logistics_message: 'Message',
  logistics_tracking_no: 'Tracking No.',
  tracking: 'Tracking',
  back: 'Back',
  login_first: 'Login first please',
  cart_empty_title: 'Cart is Empty!',
  pick_time: 'Self pick time',
  pick_address: 'Self pick address',
  is_required: 'is required',
  not_support_logsitic: 'is not support this logistic type',
};

export {labels};
